import { UploadOutlined } from '@ant-design/icons';
import { Avatar, Button, Card } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FileUploadCard.css';

const { Meta } = Card;

const FileUploadCard: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Card hoverable className="custom-card" style={{ width: '100%', marginBottom: '16px' }}>
        <div className="card-content">
          <Meta
            avatar={
              <Avatar
                size={48}
                style={{ backgroundColor: '#f6f6f6' }}
                icon={<UploadOutlined style={{ color: 'black' }} />}
              />
            }
            title={<span className="upload-description">{'Upload Video'}</span>}
          />
          <div className="buttons-container">
            {
              <>
                <Button onClick={() => navigate('/assets/add')}>Direct Upload</Button>
                <Button onClick={() => navigate('/assets-source')}>SFTP Upload</Button>
                {/* <Button onClick={() => navigate('/assets')}>Manage Video</Button> */}
              </>
            }
          </div>
        </div>
      </Card>
    </div>
  );
};

export default FileUploadCard;
